import { query } from '@/services/dc';

export default {
    namespace: 'dc',

    state: {
        data: {
            list: [],
            pagination: {},
        },
    },
    effects: {
        *query({ payload, callback }, { call, put }) {
            const response = yield call(query, payload);
            if (response && response.success) {
                yield put({
                    type: 'save',
                    payload: {
                        list: response.data.records ? response.data.records : [],
                        pagination: {
                            total: response.data.paging.recordCount,
                            pageSize: response.data.paging.pageSize,
                            current: response.data.page + 1,
                            showTotal: response.data.paging.more ? undefined : total => `共 ${total} 条`,
                        },
                    },
                });
            }
        },

    },

    reducers: {
        save(state, action) {
            return {
                ...state,
                data: action.payload,
                dcList: action.dcList
            };
        }
    },
};